import { IApp, IUpsertAppRequest } from '@bprotsyk/aso-core';

export type AppValidationField = 'appId' | 'name' | 'bundle' | 'domain' | 'appPlatform' | 'offerwallPath';
export type AppValidationErrors = Partial<Record<AppValidationField, string>>;

export function validateOfferwallAppForm(
  appState: IApp | IUpsertAppRequest,
  options: { isCreating: boolean; useOfferwallPath?: boolean }
): AppValidationErrors {
  const errors: AppValidationErrors = {};
  const appId = Number((appState as any)?.id);
  const platform = String((appState as any)?.appPlatform || '').trim().toLowerCase();

  if (options.isCreating && (!Number.isSafeInteger(appId) || appId <= 0)) {
    errors.appId = 'Вкажіть цілий App ID, більший за 0.';
  }
  if (!String(appState?.name || '').trim()) {
    errors.name = 'Вкажіть назву додатку.';
  }
  if (!String(appState?.bundle || '').trim()) {
    errors.bundle = 'Вкажіть Bundle ID.';
  }
  if (!['android', 'ios'].includes(platform)) {
    errors.appPlatform = 'Оберіть платформу.';
  }
  if (!options.isCreating && !String(appState?.domainParams?.name || '').trim()) {
    errors.domain = 'Оберіть домен.';
  }
  if (options.useOfferwallPath && !String(appState?.offerwallParams?.path || '').trim()) {
    errors.offerwallPath = 'Дочекайтеся генерації шляху офервола.';
  }

  return errors;
}

export function readServerValidationErrors(error: any): AppValidationErrors {
  const rawErrors = error?.response?.data?.fieldErrors;
  if (!rawErrors || typeof rawErrors !== 'object') return {};

  const supportedFields: AppValidationField[] = ['appId', 'name', 'bundle', 'domain', 'appPlatform', 'offerwallPath'];
  return supportedFields.reduce<AppValidationErrors>((result, field) => {
    const message = rawErrors[field];
    if (typeof message === 'string' && message.trim()) {
      result[field] = message.trim();
    }
    return result;
  }, {});
}
